(function ($) {

    $('document').ready(function () {
        if ($('.estateoffer').length !== 0) initEstatePage();
        initForms();
    });

    function initEstatePage() {
        const swiperPictures = new Swiper('.estateoffer-photos .swiper', {
            slidesPerView: 'auto',
            spaceBetween: 20,
            navigation: {
                nextEl: '.slide-next',
                prevEl: '.slide-prev',
            },
        });
        if ($('#map').length !== 0) {
            let latitude = $('#map').attr('data-latitude');
            let longitude = $('#map').attr('data-longitude');
            if (latitude && longitude && $('#map').hasClass('leaflet-container') === false) {
                var centerCoords = {lat: latitude, lng: longitude - 0.04};
                var zoom = 10;
                var zoomLimits = {
                    min: 2,
                    max: 25
                };
                var tileLayer2D = 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png';
                window.layer2D = L.tileLayer(tileLayer2D, {
                    minZoom: zoomLimits.min,
                    maxZoom: zoomLimits.max,
                    reuseTiles: true
                });
                var map = L.map('map', {
                    center: centerCoords,
                    zoom: zoom,
                    minZoom: zoomLimits.min,
                    maxZoom: zoomLimits.max,
                    touchZoom: true,
                    keyboard: false,
                    attributionControl: false,
                    scrollWheelZoom: false,
                    trackResize: true,
                    fadeAnimation: true,
                    zoomAnimation: true,
                    layerControl: false,
                    layers: [layer2D]
                });
                var myIcon = L.divIcon({
                    className: 'pinpoint',
                    iconSize: [55, 55],
                    iconAnchor: [20, 55],
                    html: '<span class="iconmap"></span>'
                });
                var marker = L.marker([latitude, longitude], {icon: myIcon}).addTo(map);
            }
        }
        $('input[name="reference"]').val($('.estateoffer-header .title').text() + ' (' + $('.estateoffer-header .ref').text().trim() + ')');
        $('input[name="reference"]').attr('readonly', 'readonly');
        $('input[name="page-url"]').val(window.location.href);
    }

    function initForms() {
        if($('.contentform').length !== 0)  {
            testLabelState();
            $('.wpcf7-form button[type="submit"], .form button[type="submit"]').click(testerFormulaire);
        }
    }

    // Fonction qui permet de gérer l'affichage des labels si un champ input est complété
    function testLabelState() {
        $("input").focusin(function() {
            $(this).parent().addClass('focus');
        });

        $("input").blur(function() {
            if ($(this).val() != "" && $(this).val() != " ") {
                $(this).parent().addClass('focus');
            }else {
                $(this).parent().removeClass('focus');
            }
        });
    }

    function testerFormulaire(e) {
        var fromId = $(this).parent().parent().parent().attr('id');
        if(fromId === undefined) fromId = $(this).parent().parent().parent().parent().attr('id');

        // vérification des saisies utilisateurs
        let nbChampVide = 0;
        $('#' + fromId+ ' .error-msg').fadeOut(200);
        $('#' + fromId+ ' .error').removeClass('error');
        $('#' + fromId+ ' .valid').removeClass('valid');

        // On vérifie que l'utilisateur a coché les cases RGPD et CGU
        if($('#' + fromId+ ' input[name="rgpd[]"]').prop( "checked" ) === false) {
            $('#' + fromId+ ' input[name="rgpd[]"]').parent().parent().parent().parent().children('.error-msg').fadeIn(300);
            nbChampVide++;
        }

        // On vérifie s'il y a des select list obligatoire
        $('#' + fromId+ ' select.wpcf7-validates-as-required').each(function () {
            if($(this).val() == '' || $(this).val() == ' ' || $(this).val() === 'Motif de la demande') {
                $(this).addClass('error');
                $(this).parent().children('.error-msg').fadeIn(300);
                nbChampVide++;
            }else {
                $(this).addClass('valid');
            }
        });

        // On vérifie la saisie des champs obligatoire
        $('#' + fromId+ ' .form input.wpcf7-validates-as-required, #' + fromId+ ' .wpcf7-form input.wpcf7-validates-as-required, #' + fromId+ ' .form input.wpcf7-validates-as-number, #' + fromId+ ' .wpcf7-form input.wpcf7-validates-as-number').each(function() {
            if($(this).val() == "" || $(this).val() == " ") { // On vérifie que le champ n'est pas vide
                nbChampVide++;
                $(this).addClass('error');
                $(this).parent().children('.error-msg').fadeIn(300);
            }else { // S'il n'est pas vide on vérifie s'il y a une verification supplémentaire sur le champ
                var name = $(this).attr('name');
                if(name === 'email') {
                    let emailVal = $(this).val();
                    emailVal = emailVal.replace('.@', '@');
                    emailVal = emailVal.replace(' ', '');
                    $(this).val(emailVal);
                    var regex = /^[\w\.\-]+[\w]@([\w-]+\.)+[\w-]{2,4}/g;
                    if (regex.test($(this).val()) == false) {
                        nbChampVide++;
                        $(this).addClass('error');
                        $(this).parent().children('.error-msg').fadeIn(300);
                    }else {
                        $(this).addClass('valid');
                    }
                }else if(name === 'telephone') {
                    var regexPhone = /^((\+|00)(3|33)\s?|0)[1-7](\s?\d{2}){4}$/;
                    var regexBelgiumPhone = /^((\+|00)(3|33)\s?|0)(\d\s?\d{3}|\d{2}\s?\d{2})(\s?\d{2}){2}$/;
                    if (regexPhone.test($(this).val()) === false && regexBelgiumPhone.test($(this).val()) === false) {
                        nbChampVide++;
                        $(this).addClass('error');
                        $(this).parent().children('.error-msg').fadeIn(300);
                    }else {
                        $(this).addClass('valid');
                    }
                }else if(name === 'code_postal') {
                    var regexCodePostal = /[0-9]{5,5}/igm;
                    if (regexCodePostal.test($(this).val()) === false) {
                        nbChampVide++;
                        $(this).addClass('error');
                        $(this).removeClass('valid');
                        $(this).parent().children('.error-msg').fadeIn(300);
                    }else {
                        $(this).addClass('valid');
                    }
                }else {
                    $(this).addClass('valid');
                }
            }
        });

        // On vérifie que les textarea requis sont renseignés
        $('#' + fromId+ ' .form textarea.wpcf7-validates-as-required, #' + fromId+ ' .wpcf7-form textarea.wpcf7-validates-as-required').each(function() {
            if($(this).val() == "" || $(this).val() == " ") { // On vérifie que le champ n'est pas vide
                nbChampVide++;
                $(this).addClass('error');
                $(this).parent().children('.error-msg').fadeIn(300);
            }else { // S'il n'est pas vide on vérifie s'il y a une verification supplémentaire sur le champ
                $(this).addClass('valid');
            }
        });

        if(nbChampVide !== 0) {
            e.preventDefault();
            $("html, body").animate({ scrollTop: $('#' + fromId+ ' .error').offset().top - 160 }, 500);
        }else {
            $('body > .loading').addClass('show');
            $("html, body").css('overflow', 'hidden');
        }
    }

    document.addEventListener( 'wpcf7mailsent', function( event ) {
        let formulaireID = $(event.target).children('.form').attr('id');
        $('.loading').removeClass('show');
        $("html, body").removeAttr('style');
        $(event.target).parent().parent().find('.text').hide();
        $(event.target).children('.form').fadeOut(400, function() {
            $(event.target).find('.validation-msg').fadeIn(400);
        });
    });

})(jQuery);